<div class="modify-book-widget-multi-city-mobile pt-[2px]">
  @if (bookWidgetFields() && bookWidgetAem()) {
    <div class="flex flex-col gap-24 pb-[150px]">
      <div class="flex flex-col gap-8">
        <idp-select-mach-core
          class="h-[64px]"
          id="trip-type-field"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().tripTypesField.tripTypeAriaLabel"
          [disabled]="bookWidgetFields().tripTypesField.disable"
          [dropdownOptions]="bookWidgetFields().tripTypesField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.tripType
            )
          "
        ></idp-select-mach-core>
        <idp-select-mach-core
          class="h-[64px]"
          icon="/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg"
          [isTitleHidden]="true"
          [title]="bookWidgetAem().passengerField.passengerAriaLabel"
          [hideDropdownListIcon]="true"
          [disabled]="bookWidgetFields().passengerField.disable"
          [dropdownOptions]="bookWidgetFields().passengerField.dropdownOptions"
          (selectionChange)="
            onDropdownSelectionChange(
              $event,
              bookWidgetFieldUpdateTypes.passenger
            )
          "
        ></idp-select-mach-core>
      </div>
      <div class="flex flex-col gap-16">
        @for (
          airportItem of bookWidgetFields().airportsField.airports;
          track i;
          let i = $index
        ) {
          <div class="text-label-sm-semibold text-static flex flex-col gap-8">
            {{ bookWidgetAem().airportsField.flight }} {{ i + 1 }}
            <idp-multicity-route-picker-mach-core
              class="min-h-[64px] h-max"
              [routeIndex]="i"
              [routePickerContent]="{
                origin: {
                  title: bookWidgetAem().airportsField.from,
                  subtitle: bookWidgetAem().airportsField.yourOrigin
                },
                destination: {
                  title: bookWidgetAem().airportsField.to,
                  subtitle: bookWidgetAem().airportsField.yourDestination
                },
                ariaLabels: {
                  origin:
                    bookWidgetAem().airportsField.originAriaLabel +
                    (bookWidgetFields().airportsField.airports[i]
                      .fromAirportcode.length
                      ? ' ' +
                        bookWidgetFields().airportsField.airports[i]
                          .fromAirportcode +
                        ', ' +
                        bookWidgetFields().airportsField.airports[i].fromCity
                      : ''),
                  swapArrow: bookWidgetAem().airportsField.swapAriaLabel,
                  departure:
                    bookWidgetAem().airportsField.departureAriaLabel +
                    (bookWidgetFields().airportsField.airports[i].toAirportcode
                      .length
                      ? ' ' +
                        bookWidgetFields().airportsField.airports[i]
                          .toAirportcode +
                        ', ' +
                        bookWidgetFields().airportsField.airports[i].toCity
                      : '')
                }
              }"
              [routePickerCities]="{
                destinationCode:
                  bookWidgetFields().airportsField.airports[i].toAirportcode,
                destinationName:
                  bookWidgetFields().airportsField.airports[i].toCity,
                destinationRegion: '',
                originCode:
                  bookWidgetFields().airportsField.airports[i].fromAirportcode,
                originName:
                  bookWidgetFields().airportsField.airports[i].fromCity,
                originRegion: ''
              }"
              [routePickerError]="
                bookWidgetFields().airportsField.fieldErrorInfo
                  ?.routePickerField
              "
              [recentSearchList]="recentSearchList()"
              [savedSearchList]="savedSearchList()"
              [searchModalTabs]="searchModalTabs()"
              [isFullscreen]="isFullscreen()"
              [predictiveSearchData]="predictiveSearchData()"
              (swapClicked)="swapClicked.emit(i)"
              (searchModalTriggerClicked)="
                searchModalTriggerClicked.emit($event)
              "
              (searchModalEvent)="searchModalEvent.emit($event)"
            ></idp-multicity-route-picker-mach-core>
            <idp-date-picker-mach-core
              class="min-h-[64px] h-max"
              [selectedTripType]="
                bookWidgetFields().tripTypesField.selectedTripType
              "
              [selectedRange]="bookWidgetFields().datesField.dates[i]"
              [fieldErrorInfo]="
                bookWidgetFields().datesField.fieldErrorInfo?.[i]
              "
              [bookWidgetAem]="bookWidgetAem()"
              [datepickerConfig]="datepickerConfig()"
              (selectedDateRange)="
                onDateSelectionChange(
                  $event,
                  bookWidgetFieldUpdateTypes.datesChange,
                  i
                )
              "
            ></idp-date-picker-mach-core>
            <idp-connection-picker-mach-core
              class="min-h-[64px] h-max"
              [routeIndex]="i"
              [placeholder]="bookWidgetAem().airportsField.connectionLabel"
              [connection]="{
                connectionCity: airportItem.connectionCity ?? '',
                connectionAirport: airportItem.connectionAirport ?? ''
              }"
              [recentSearchList]="recentSearchList()"
              [savedSearchList]="savedSearchList()"
              [searchModalTabs]="searchModalTabs()"
              [connectionError]="
                bookWidgetFields().airportsField.fieldErrorInfo
                  ?.connectionAirportField
              "
              [isFullscreen]="isFullscreen()"
              [predictiveSearchData]="predictiveSearchData()"
              [helpIconAriaLabel]="bookWidgetAem().helpIconAriaLabel"
              (searchModalTriggerClicked)="
                searchModalTriggerClicked.emit($event)
              "
              (searchModalEvent)="searchModalEvent.emit($event)"
              (showConnectionAirportInfoModal)="
                infoIconClickHandler(
                  bookWidgetFieldInfoTypes.CONNECTION_AIRPORT
                )
              "
              (clearConnectionAirport)="clearConnectionAirport(i)"
            ></idp-connection-picker-mach-core>
          </div>
        }
      </div>
      <div class="flex flex-row justify-between">
        <div class="flex items-center">
          @if (bookWidgetFields().airportsField.showAddFlightBtn) {
            <a
              tabindex="0"
              class="mc-desktop-container-row-3__item mc-desktop-add-flight link link-md"
              [attr.aria-label]="bookWidgetAem().airportsField.addFlight"
              (click)="addFlight.emit()"
              (keydown.enter)="addFlight.emit()"
            >
              <img
                src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/plus.svg"
                alt=""
              />
              {{ bookWidgetAem().airportsField.addFlight }}
            </a>
          }
        </div>
        <div class="flex items-center">
          @if (bookWidgetFields().airportsField.showRemoveFlightBtn) {
            <a
              tabindex="0"
              class="link link-md mc-desktop-remove-flight"
              [attr.aria-label]="bookWidgetAem().airportsField.removeFlight"
              (click)="removeFlight.emit()"
              (keydown.enter)="removeFlight.emit()"
            >
              <img
                src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/minus.svg"
                alt=""
              />
              {{ bookWidgetAem().airportsField.removeFlight }}
            </a>
          }
        </div>
      </div>
      <div class="flex flex-col gap-16">
        @if (!bookWidgetFields().shopMilesField.hide) {
          <div class="flex items-center justify-between">
            <label
              for="shopMiles"
              class="text-static mb-0 text-label-md-medium"
              [ngClass]="{
                '!text-disabled': bookWidgetFields().shopMilesField.disable
              }"
            >
              {{ bookWidgetAem().shopMilesField.shopWithMiles }}
            </label>
            <input
              #shopMilesCheckboxElement
              type="checkbox"
              id="shopMiles"
              class="toggle"
              [disabled]="bookWidgetFields().shopMilesField.disable"
              [attr.aria-label]="bookWidgetAem().shopMilesField.shopWithMiles"
              [checked]="bookWidgetFields().shopMilesField.checked"
              (change)="
                onToggleChange($event, bookWidgetFieldUpdateTypes.shopMiles);
                analyticsEvent.emit({ el: shopMilesCheckboxElement })
              "
            />
          </div>
        }
        @if (!bookWidgetFields().basicFaresField.hide) {
          <div class="flex items-center justify-between">
            <label
              for="basicFaresField"
              class="text-static mb-0 text-label-md-medium"
              [ngClass]="{
                '!text-disabled': bookWidgetFields().basicFaresField.disable
              }"
            >
              {{ bookWidgetAem().includeBasicField.includeBasic }}
            </label>
            <input
              #basicFaresCheckboxElement
              type="checkbox"
              id="basicFaresField"
              class="toggle"
              [attr.aria-label]="bookWidgetAem().includeBasicField.includeBasic"
              [checked]="bookWidgetFields().basicFaresField.checked"
              [disabled]="bookWidgetFields().basicFaresField.disable"
              (change)="
                onToggleChange($event, bookWidgetFieldUpdateTypes.basicFares);
                analyticsEvent.emit({ el: basicFaresCheckboxElement })
              "
            />
          </div>
        }
        @if (!bookWidgetFields().refundableFareField.hide) {
          <div class="flex items-center justify-between">
            <div class="flex gap-[5px]">
              <label
                for="refundableFares"
                class="text-static mb-0 text-label-md-medium"
                [ngClass]="{
                  '!text-disabled':
                    bookWidgetFields().refundableFareField.disable
                }"
              >
                {{ bookWidgetAem().refundableFareField.refundableOnly }}
              </label>
              <img
                class="grayscale-effect"
                src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
                [attr.aria-label]="
                  bookWidgetAem().refundableFareField.refundableOnly +
                  ' ' +
                  bookWidgetAem().helpIconAriaLabel
                "
                role="button"
                tabindex="0"
                (click)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
                (keydown.enter)="
                  infoIconClickHandler(
                    bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
                  )
                "
              />
            </div>
            <input
              #refundableFaresCheckboxElement
              type="checkbox"
              id="refundableFares"
              class="toggle"
              [disabled]="bookWidgetFields().refundableFareField.disable"
              [checked]="bookWidgetFields().refundableFareField.checked"
              [attr.aria-label]="
                bookWidgetAem().refundableFareField.refundableOnly
              "
              (change)="
                onToggleChange(
                  $event,
                  bookWidgetFieldUpdateTypes.refundableFare
                );
                analyticsEvent.emit({ el: refundableFaresCheckboxElement })
              "
            />
          </div>
        }
      </div>

      <idp-options-expander-mach-core
        [content]="bookWidgetAem().advancedSearchBtn"
        [isExpanded]="isAdvancedSearchExpanded()"
        (expandedEmit)="toggleAdvSearchExpandedEvent.emit()"
        (analyticsEvent)="analyticsEvent.emit({ el: $event })"
      ></idp-options-expander-mach-core>

      @if (isAdvancedSearchExpanded()) {
        <div class="flex flex-col gap-16">
          @if (!bookWidgetFields().bestFareOptionsField.hide) {
            <idp-best-fare-options-mach-core
              [title]="bookWidgetAem().bestFareOptionsField.bestFare"
              [disabled]="bookWidgetFields().bestFareOptionsField.disable"
              [infoModalContent]="
                bookWidgetAem().bestFareOptionsField.infoModal
              "
              [infoTooltipOptions]="{
                positions: 'top-right',
                color: 'high-contrast',
                triggerEvent: 'hover'
              }"
              [dropdownOptions]="
                bookWidgetFields().bestFareOptionsField.dropdownOptions
              "
              (bestFareOptionsChange)="
                onDropdownSelectionChange(
                  $event,
                  bookWidgetFieldUpdateTypes.bestFareOptions
                )
              "
            ></idp-best-fare-options-mach-core>
          }
          @if (!bookWidgetFields().meetingEventCodeField.hide) {
            <idp-meeting-code-mach-core
              [placeholder]="bookWidgetAem().meetingEventCodeField.placeholder"
              [title]="bookWidgetAem().meetingEventCodeField.meetingEventCode"
              [value]="
                bookWidgetFields().meetingEventCodeField.meetingEventCodeValue
              "
              [disabled]="bookWidgetFields().meetingEventCodeField.disable"
              [infoModalContent]="
                bookWidgetAem().meetingEventCodeField.infoModal
              "
              [errorMessage]="
                bookWidgetFields().meetingEventCodeField.fieldErrorInfo
                  ?.errorMessage
              "
              [tooltipOptions]="{
                positions: 'top-right',
                color: 'high-contrast',
                triggerEvent: 'hover'
              }"
              [disclaimerMessage]="
                bookWidgetFields().meetingEventCodeField.disclaimerMessage
              "
              (valueChange)="
                onInputFieldChange(
                  $event,
                  bookWidgetFieldUpdateTypes.meetingEventCode
                )
              "
            ></idp-meeting-code-mach-core>
          }
          @if (!bookWidgetFields().edocsLink.hide) {
            <a
              #edocsLinkElement
              class="link link-sm"
              [ngClass]="{
                '!text-disabled pointer-events-none':
                  bookWidgetFields().edocsLink.disable
              }"
              [href]="
                bookWidgetFields().edocsLink.disable
                  ? null
                  : bookWidgetFields().edocsLink.src
              "
              (click)="analyticsEvent.emit({ el: edocsLinkElement })"
            >
              {{ bookWidgetAem().edocsLink }}
            </a>
          }
        </div>
      }
      <div
        class="cta-btn-container fixed bottom-0 left-0 right-0 py-[24px] border-t border-[#AAADBD] bg-surface-02 flex justify-center items-center"
      >
        <button
          id="findFilghtsCta"
          #findFlightButton
          class="button button-primary button-md w-screen max-w-[343px] tablet:max-w-[520px]"
          role="button"
          tabindex="0"
          [attr.aria-label]="bookWidgetAem().searchBtn"
          data-acdl-name="flights:find flights"
          data-acdl-action="flight search initiation:flights search"
          data-acdl-page-section="header:book:flights"
          (click)="onFindFlightClick(findFlightButton)"
          (keydown.enter)="onFindFlightClick(findFlightButton)"
        >
          {{ bookWidgetAem().searchBtn }}
        </button>
      </div>
    </div>
  }
</div>
